const getAssets = require.context('../assets', true);

export default getAssets;
